define(
  'app/views/product_category_single_page_view',[
    'app/setup', 'app/collections/search_products', 'app/models/search_product',
    'app/views/search_view'
  ],
  function(takhfifan, searchProducts, searchProduct, searchView) {
    takhfifan.ProductCategorySinglePageView = takhfifan.SearchView.extend({
      events: {
      },

      template: ( $('#search-list-template').length > 0 ) ?
        _.template( $('#search-list-template').html() ) : '',

      render: function() {
        this.$(".tkh-special-category-single-inner").html(
          this.template({
            products:this.collection.toJSON(),
            pagination: this.collection.pagination
          })
        );
        takhfifan.eventHub.trigger('lazyLoad:load');
        //this.stopLoading();
      },

      updateQuery: function() {
        this.collection.fetch({reset: true});
      },

      load: function(force) {
        if(!this.$spinner.hasClass('loading') && this.isOnScreen(this.$spinner)){
          this.increasePage();
        }
      },

      //wait 100ms after user scrolling is done
      lazyPageLoad : _.debounce(function () {
        this.load();
      }, 100),

      increasePage: function() {
        var thisView = this;
        if(_.isUndefined(this.collection.pageNum)) {
          this.collection.pageNum = 1;
        }
        if(this.collection.pageNum + 1 <= this.collection.pagination.lastPage) {
          this.setAsLoading();
          this.collection.pageNum = this.collection.pageNum + 1;
          this.collection.fetch({
            remove:false,
            success: function (collectoin, response, options) {
              thisView.$spinner.before(
                thisView.template({
                  products:response.models,
                  pagination: thisView.collection.pagination
                })
              );
              thisView.stopLoading();
              //check if user already scrolled down again...
              thisView.load();
            }
          });
        }
      },

      setAsLoading: function() {
        this.$spinner.addClass('loading');
      },

      stopLoading: function() {
        this.$spinner.removeClass('loading');
      },

      initialize: function(options) {
        this.options = options;
        // var _this = this;
        var initData = this.$el.data('initialize');
        var categoryId = this.$el.data('categoryid');
        var initModels = initData.models;
        if(initModels && initModels.length > 0) {
          this.collection = new takhfifan.ProductCategoryAllSinglePageProducts(initModels);
          if(!_.isUndefined(categoryId)) {
            this.collection.categoryId = categoryId;
          }
        }
        else {
          this.collection = new takhfifan.ProductCategoryAllSinglePageProducts();
        }
        this.collection.q = this.$("#search-field").val();

        if(initData.pagination) {
          this.collection.pagination = initData.pagination;
        }
        // Note : we don't need to render whole collection with every update.
        // this.collection.bind("change reset add remove", this.render, this);
        this.collectionAbruptFetch=true;
        takhfifan.eventHub.on('window:scroll', this.lazyPageLoad, this);

        this.$spinner = $('<div class="cnt-loading scroll-trigger"><span class="spinner"></span></div>');
        this.$(".tkh-special-category-single-inner").append(this.$spinner);

        // check if page is already scrolled (such as page reload)
        this.load();

        this.queryTimer = [];
        this.collectionAbruptFetch=true;
      }
    });
  });

